module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("Dorothy Meets Button-bright")]), _vm._v(" "), _c('p', {
    staticClass: "img2"
  }, [_c('img', {
    staticClass: "calibre23",
    attrs: {
      "alt": "Dorothy Meets Button-bright",
      "id": "id-8289643387768160630",
      "src": "Images/img0012.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("THE seventh road was a good road, and curved this way and that—winding\nthrough green meadows and fields covered with daisies and buttercups and\npast groups of shady trees. There were no houses of any sort to be seen,\nand for some distance they met with no living creature at all.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("Dorothy began to fear they were getting a good way from the\n"), _c('i', {
    staticClass: "calibre17"
  }, [_vm._v("farm-house")]), _vm._v(", since here everything was strange to her; but it would do\nno good at all to go back where the other roads all met, because the\nnext one they chose might lead her just as far from home.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("She kept on beside the shaggy man, who whistled cheerful tunes to\nbeguile the journey, until by-and-by they followed a turn in the road\nand saw before them a big chestnut tree making a shady spot over the\nhighway. In the shade sat a little boy dressed in sailor clothes, who\nwas digging a hole in the earth with a bit of wood. He must have been\ndigging some time, because the hole was already big enough to drop a\nfoot-ball into.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("Dorothy and Toto and the shaggy man came to a halt before the little\nboy, who kept on digging in a sober and persistent fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Who are you?\" asked the girl.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("He looked up at her calmly. His face was round and chubby and his eyes\nwere big, blue, and earnest.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"I'm Button-Bright,\" said he.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"But what's you real name?\" she inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Button-Bright.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"That isn't a really-truly name!\" she exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Isn't it?\" he asked, still digging.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"'Course not. It's just a—a thing to call you by. You must have a\nname.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Must I?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"To be sure. What does your mamma call you?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("He paused in his digging and tried to think.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Papa always said I was bright as a button; so mamma always called me\nButton-Bright,\" he said.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"What is your papa's name?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Just Papa.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"What else?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Don't know.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Never mind,\" said the shaggy man, smiling. \"We'll call the boy\nButton-Bright, as his mamma does. That name is as good as any, and\nbetter than some.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("Dorothy watched the boy dig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Where do you live?\" she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Don't know,\" was the reply.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"How did you come here?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Don't know,\" he said again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Don't you know where you came from?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"No,\" said he.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Why, he must be lost,\" she said to the shaggy man. She turned to the\nboy once more.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"What are you going to do?\" she inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Dig,\" said he.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"But you can't dig forever; and what are you going to do then?\" she\npersisted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Don't know,\" said the boy.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"But you "), _c('i', {
    staticClass: "calibre17"
  }, [_vm._v("must")]), _vm._v(" know "), _c('i', {
    staticClass: "calibre17"
  }, [_vm._v("something")]), _vm._v(",\" declared Dorothy, getting provoked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Must I?\" he asked, looking up in surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Of course you must.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"What must I know?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"What's going to become of you, for one thing,\" she answered.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Do "), _c('i', {
    staticClass: "calibre17"
  }, [_vm._v("you")]), _vm._v(" know what's going to become of me?\" he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Not—not 'zactly,\" she admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Do you know what's going to become of "), _c('i', {
    staticClass: "calibre17"
  }, [_vm._v("you")]), _vm._v("?\" he continued, earnestly.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "calibre7",
    attrs: {
      "alt": "image not available",
      "id": "id-7047458671760463376",
      "src": "Images/img0013.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"I can't say I do,\" replied Dorothy, remembering her present\ndifficulties.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("The shaggy man laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"No one knows everything, Dorothy,\" he said.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"But Button-Bright doesn't seem to know "), _c('i', {
    staticClass: "calibre17"
  }, [_vm._v("anything")]), _vm._v(",\" she declared. \"Do\nyou, Button-Bright?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("He shook his head, which had pretty curls all over it, and replied with\nperfect calmness:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Don't know.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("Never before had Dorothy met with any one who could give her so little\ninformation. The boy was evidently lost, and his people would be sure to\nworry about him. He seemed two or three years younger than Dorothy, and\nwas prettily dressed, as if some one loved him dearly and took much\npains to make him look well. How, then, did he come to be in this lonely\nroad? she wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("Near Button-Bright, on the ground, lay a sailor hat with a gilt anchor\non the band. His sailor trousers were long and wide at the bottom, and\nthe broad collar of his blouse had gold anchors sewed on its corners.\nThe boy was still digging at his hole.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Have you ever been to sea?\" asked Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"To see what?\" answered Button-Bright.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"I mean have you ever been where there's water?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Yes,\" said Button-Bright; \"there's a well in our back yard.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"You don't understand,\" cried Dorothy. \"I mean, have you ever been on a\nbig ship floating on a big ocean?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Don't know,\" said he.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Then why do you wear sailor clothes?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Don't know,\" he answered, again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("Dorothy was in despair.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"You're just "), _c('i', {
    staticClass: "calibre17"
  }, [_vm._v("awful")]), _vm._v(" stupid, Button-Bright,\" she said.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Am I?\" he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Yes, you are.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Why?\" looking up at her with big eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("She was going to say: \"Don't know,\" but stopped herself in time.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"That's for you to answer,\" she replied.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"It's no use asking Button-Bright questions,\" said the shaggy man, who\nhad been eating another apple; \"but some one ought to take care of the\npoor little chap, don't you think? So he'd better come along with us.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("Toto had been looking with great curiosity into the hole which the boy\nwas digging, and growing more and more excited every minute, perhaps\nthinking that Button-Bright was after some wild animal. The little dog\nbegan barking loudly and jumped into the hole himself, where he began to\ndig with his tiny paws, making the earth fly in all directions. It\nspattered over the boy. Dorothy seized him and raised him to his feet,\nbrushing his clothes with her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Stop that, Toto!\" she called. \"There aren't any mice or woodchucks in\nthat hole, so don't be foolish.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("Toto stopped, sniffed at the hole suspiciously, and jumped out of it,\nwagging his tail as if he had done something important.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Well,\" said the shaggy man, \"let's start on, or we won't get anywhere\nbefore night comes.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Where do you expect to get to?\" asked Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"I'm like Button-Bright; I don't know,\" answered the shaggy man, with a\nlaugh. \"But I've learned from long experience that every road leads\nsomewhere, or there wouldn't be any road; so it's likely that if we\ntravel long enough, my dear, we will come to some place or another in\nthe end. What place it will be we can't even guess at this moment, but\nwe're sure to find out when we get there.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("\"Why, yes,\" said Dorothy; \"that seems reas'n'ble, Shaggy Man.\"")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "calibre7",
    attrs: {
      "alt": "image not available",
      "id": "id-466872763303307103",
      "src": "Images/img0014.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "id": "CHAP_3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0